
<input
  :ref="`textInput_child_${refId}`"

  :value="textInput_child"
  :type="inputType"
  :placeholder="placeholder"

  class="input-area no-spinner"
  :class="focusBoxShadow ? `focus-box-shadow-and-border-color-687EFF textInput_child_${refId}` : `textInput_child_${refId}`"
  style="width: 100%; background-color: #ffffff; border-radius: 8px; font-weight: 400; line-height: 20px; color: #0D0E17"
  :style="{height: height, border: border, padding: padding, fontSize: fontSize}"

  @input="onInput"
  @compositionend="onCompositionEnd"
  @keyup.enter="keyup_enter"
  @keyup.esc="keyup_esc"
  @keydown.tab.exact.prevent="onTab"
  @keydown.shift.tab.exact.prevent="onShiftTab"
>
